/* Common MESSAGE */

/* admin, user 동기화 필수!! */

//확인
export const COM_CNF_MSG_001 = '가 등록되었습니다.'
export const COM_CNF_MSG_002 = '가 수정되었습니다.'
export const COM_CNF_MSG_003 = '가 삭제되었습니다.'
export const COM_CNF_MSG_004 = '가 저장되었습니다.'

//정보
export const COM_INF_MSG_001 = '등록된 글이 없습니다.'
export const COM_INF_MSG_002 = '2자 이상 검색해 주세요'

//에러
export const COM_ERR_MSG_001 = '필수 입력항목입니다.'
export const COM_ERR_MSG_002 = '숫자만 입력 가능합니다.'
export const COM_ERR_MSG_003 = '자 이하로 입력해 주십시오.'
export const COM_ERR_MSG_004 = '값 이하로 입력해 주십시오.'
export const COM_ERR_MSG_005 = '을 입력해 주세요.'
export const COM_ERR_MSG_006 = '를 입력해 주세요.'
export const COM_ERR_MSG_007 = '을 선택해 주세요.'
export const COM_ERR_MSG_008 = '를 선택해 주세요.'
export const COM_ERR_MSG_009 = '첨부하실 파일을 추가해 주세요.'
export const COM_ERR_MSG_010 = ''
export const COM_ERR_MSG_011 =
    '파일은 1개만 첨부가 가능합니다(png, jpg만 가능).'
export const COM_ERR_MSG_012 = ''
export const COM_ERR_MSG_013 = '파일 사이즈는 5MB를 초과할 수 없습니다.'
export const COM_ERR_MSG_014 = '파일 사이즈는 20MB를 초과할 수 없습니다.'
export const COM_ERR_MSG_015 = '파일 사이즈는 50MB를 초과할 수 없습니다.'
export const COM_ERR_MSG_016 = ''

/**
 * 기본 명명규칙
 * * 기본적으로 PAGE_ID 기반으로 화면에서 사용하는 문구를 구분
 * * TYPE은 작업자가 알아보기 쉽도록 구분하는 역할로 기본 이외에 필요한 경우 아래 추가 후 사용
 * * MSG - Message, ERR - error, CNF - confirm, INF - info, TTL - title, LBL - label, PLH - placeholder
 *
 * case 공통 메시지
 * COM_{TYPE}_{SEQ}
 *
 * case 개별 메시지
 * {PAGE_ID}_{TYPE}_{SEQ}
 *
 * 문자열에 placeholder가 있는 경우 comUtil.ts의 getMsg() 함수를 사용하여 변환
 *
 */

//공통
export const COM_CNF_001 = '선택'
export const COM_CNF_002 = '확인'
export const COM_CNF_003 = '취소'

export const COM_LBL_001 = '이름'
export const COM_LBL_002 = '이름'

export const COM_PLH_001 = '이름 입력'

//휴대폰 인증 COMATH0102
export const COMATH0102_TTL_001 = '휴대폰인증'
export const COMATH0102_LBL_001 = '확인'
export const COMATH0102_LBL_002 = '확인'
export const COMATH0102_LBL_003 = '휴대폰번호'
export const COMATH0102_LBL_004 = '인증번호'
export const COMATH0102_LBL_005 = '재요청'
export const COMATH0102_TTL_002 = (
    <>
        본인확인을 위해
        <br />
        휴대폰인증을 진행해주세요
    </>
)
export const COMATH0102_TTL_003 = '휴대폰인증 약관 동의'
export const COMATH0102_TTL_004 = '통신사 선택'
export const COMATH0102_TTL_005 = '통신사'

export const COMATH0102_ERR_001 =
    '인증시간이 지났습니다. 인증번호를 [재요청]해 주세요.'
export const COMATH0102_PLH_001 = "'-'없이 입력"
export const COMATH0102_PLH_002 = '숫자 6자리 입력'

//본인인증동의
export const COMATH0104_TTL_001 = '본인인증동의'
export const COMATH0104_LBL_002 = '고유식별 정보처리 동의'

//GATEWAY PAGE
export const MAIAPP0101_ERR_001 =
    '[정상경로]로 유입되지 않아 메인으로 이동합니다.'
export const MAIAPP0101_ERR_002 = '요청하신 URL은 유효하지 않은 주소입니다.'
export const MAIAPP0101_ERR_003 = '관련 상품조회에 실패 하였습니다.'

// 본인인증 및 전자서명 (COMATH0105/COMATH0106/COMATH0107/COMATH0108)
export const COMATH_SIGN_TTL_001 = '본인확인'
export const COMATH_SIGN_TTL_002 = '전자서명'
export const COMATH_SIGN_TTL_003 = 'IBK인증서 인증'
export const COMATH_SIGN_TTL_004 = '토스뱅크 인증'
export const COMATH_SIGN_TTL_005 = '카카오뱅크 인증'
export const COMATH_SIGN_TTL_006 = '본인확인 방법을 선택해 주세요'
export const COMATH_SIGN_TTL_007 = (
    <>
        본인확인을 위해 인증을
        <br />
        진행해주세요
    </>
)
export const COMATH_SIGN_TTL_008 = (
    <>
        공공마이데이터 이용을 위해
        <br />
        전자서명 인증수단을 선택해 주세요
    </>
)
export const COMATH_SIGN_TTL_009 = (
    <>
        공공마이데이터 이용을 위해
        <br />
        전자서명을 진행해주세요
    </>
)
export const COMATH_SIGN_TTL_010 = '본인확인 인증 약관 동의'
export const COMATH_SIGN_TTL_011 = '공공마이데이터 서비스 이용 동의'
export const COMATH_SIGN_LBL_001 = '휴대폰 본인인증'
export const COMATH_SIGN_LBL_002 = 'IBK인증서'
export const COMATH_SIGN_LBL_003 = '토스 인증서'
export const COMATH_SIGN_LBL_004 = '카카오뱅크 인증서'
export const COMATH_SIGN_LBL_005 =
    'i-ONE Bank(앱)에서 발급받은 후<br />사용할 수 있어요'
export const COMATH_SIGN_LBL_006 = '이름'
export const COMATH_SIGN_LBL_007 = '휴대폰번호'
export const COMATH_SIGN_LBL_008 = '확인'
export const COMATH_SIGN_PLH_001 = '이름 입력'
export const COMATH_SIGN_PLH_002 = "'-'없이 입력"
export const COMATH_SIGN_ERR_001 = '이름을 확인해주세요.'
export const COMATH_SIGN_ERR_002 = '휴대폰번호를 확인해주세요.'
export const COMATH_SIGN_ERR_003 = '생년월일 6자리 및 성별을 입력해주세요.'
